// Injects the active UI language as the Accept-Language header on every fetch()
// request so the backend can localize responses (e.g. error messages). The axios
// client sets this header via its own interceptor; this covers raw fetch() calls.

const STORAGE_KEY = 'structura.language'
const INSTALLED_FLAG = '__structuraAcceptLanguageInstalled'

function currentLanguage(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'nb'
  } catch {
    return 'nb'
  }
}

// Wrap window.fetch once (idempotent). Adds Accept-Language only when the caller
// has not already set it, reading localStorage per call so it tracks language changes.
export function installAcceptLanguageFetch(): void {
  if (typeof window === 'undefined' || typeof window.fetch !== 'function') {
    return
  }
  const w = window as unknown as Record<string, unknown>
  if (w[INSTALLED_FLAG] === true) {
    return
  }
  w[INSTALLED_FLAG] = true

  const originalFetch: typeof window.fetch = window.fetch.bind(window)
  window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined))
    if (!headers.has('Accept-Language')) {
      headers.set('Accept-Language', currentLanguage())
    }
    return originalFetch(input, { ...init, headers })
  }
}
